import React, { useEffect } from "react";
import { MaterialReactTable } from "material-react-table";
import { Button } from "@mui/material";
import { useReceiptVoucherContext } from "../../context/ReceiptVoucherContext";
import { formatDate } from "../../utils/dateFormatter";
import "./receiptVouchers.css";

const ReceiptVouchers = () => {
  const { vouchers, loading, getReceiptVouchers } = useReceiptVoucherContext();

  useEffect(() => {
    getReceiptVouchers();
  }, []);
  console.log(vouchers);

  const columns = [
    {
      accessorKey: "id",
      header: "رقم السند",
      size: 80,
      Cell: ({ row }) => (
        <a
          href={`/receipt-voucher/${row.original.id}`}
          style={{
            color: "#0066ff",
            textDecoration: "none",
            fontWeight: 600,
          }}
          onMouseEnter={(e) => (e.target.style.textDecoration = "underline")}
          onMouseLeave={(e) => (e.target.style.textDecoration = "none")}
        >
          #{row.original.id}
        </a>
      ),
    },
    {
      accessorKey: "party_name",
      header: "اسم الطرف",
      size: 200,
      Cell: ({ row }) => (
        <a
          href={`/${row.original.party_type}/${
            row.original.party_type === "supplier"
              ? row.original.supplier_id
              : row.original.customer_id
          }`}
          style={{
            color: "#3b82f6",
            textDecoration: "none",
            fontWeight: 500,
          }}
          onMouseEnter={(e) => (e.target.style.textDecoration = "underline")}
          onMouseLeave={(e) => (e.target.style.textDecoration = "none")}
        >
          {row.original.party_name}
        </a>
      ),
    },
    {
      accessorKey: "party_phone",
      header: "هاتف الطرف",
      size: 150,
    },
    {
      accessorKey: "invoice_id",
      header: "رقم الفاتورة",
      size: 140,
      Cell: ({ row }) => (
        <a
          href={`/sales-invoice/${row.original.invoice_id}`}
          style={{
            color: "#10b981",
            textDecoration: "none",
            fontWeight: 500,
          }}
          onMouseEnter={(e) => (e.target.style.textDecoration = "underline")}
          onMouseLeave={(e) => (e.target.style.textDecoration = "none")}
        >
          #{row.original.invoice_id}
        </a>
      ),
    },
    {
      accessorKey: "amount",
      header: "المبلغ المدفوع",
      size: 150,
      Cell: ({ cell }) => `${parseFloat(cell.getValue()).toFixed(2)} ₪`,
    },
    {
      accessorKey: "payment_type",
      header: "نوع الدفع",
      size: 120,
      Cell: ({ cell }) => (
        <span
          style={{
            padding: "4px 12px",
            borderRadius: "12px",
            fontSize: "0.875rem",
            fontWeight: 600,
            backgroundColor: cell.getValue() === "كاش" ? "#d1fae5" : "#dbeafe",
            color: cell.getValue() === "كاش" ? "#065f46" : "#1e40af",
          }}
        >
          {cell.getValue() == "كاش" ? "كاش" : "شيك"}
        </span>
      ),
    },
    {
      accessorFn: (row) => {
        if (row.payment_type === "كاش") return "-";
        const parts = [];
        if (row.check_number) parts.push(`رقم الشيك: ${row.check_number}`);
        if (row.check_bank) parts.push(`البنك: ${row.check_bank}`);
        if (row.check_due_date)
          parts.push(`تاريخ الاستحقاق: ${formatDate(row.check_due_date)}`);
        return parts.length > 0 ? parts.join(" | ") : "-";
      },
      id: "check_info",
      header: "معلومات الشيك",
      size: 250,
      Cell: ({ row }) => {
        if (row.original.payment_type === "كاش") {
          return <span style={{ color: "#999", fontSize: "18px" }}>-</span>;
        }

        return (
          <div style={{ fontSize: "0.85rem", lineHeight: "1.6" }}>
            {row.original.check_number && (
              <div>
                <strong>رقم الشيك:</strong> {row.original.check_number}
              </div>
            )}
            {row.original.check_bank && (
              <div>
                <strong>البنك:</strong> {row.original.check_bank}
              </div>
            )}
            {row.original.check_due_date && (
              <div>
                <strong>تاريخ الاستحقاق:</strong>{" "}
                {formatDate(row.original.check_due_date)}
              </div>
            )}
            {!row.original.check_number &&
              !row.original.check_bank &&
              !row.original.check_due_date && (
                <span style={{ color: "#999" }}>-</span>
              )}
          </div>
        );
      },
    },
    {
      accessorKey: "created_at",
      header: "تاريخ السند",
      size: 150,
      Cell: ({ cell }) => formatDate(cell.getValue()),
    },
    {
      accessorKey: "notes",
      header: "ملاحظات",
      size: 200,
      Cell: ({ cell }) => cell.getValue() || "-",
    },
  ];

  return (
    <div className="receipt-vouchers-page">
      <div className="page-container">
        <div className="page-header">
          <h2 className="page-title">سندات القبض ({vouchers.length})</h2>
          <a
            href="/new-receipt-voucher"
            style={{
              backgroundColor: "#667eea",
              color: "white",
              padding: "10px 20px",
              borderRadius: "4px",
              fontWeight: 600,
              textDecoration: "none",
              display: "inline-block",
            }}
          >
            + إضافة سند قبض جديد
          </a>
        </div>

        {loading ? (
          <p className="loading-text">جارٍ تحميل البيانات...</p>
        ) : (
          <div className="table-wrapper">
            <MaterialReactTable
              columns={columns}
              data={vouchers}
              enableColumnResizing
              enableStickyHeader
              enablePagination
              muiTableContainerProps={{ sx: { maxHeight: "600px" } }}
              initialState={{
                pagination: { pageSize: 25, pageIndex: 0 },
                density: "compact",
              }}
              muiTableProps={{
                sx: {
                  tableLayout: "fixed",
                },
              }}
              muiTableHeadCellProps={{
                sx: {
                  backgroundColor: "#f7fafc",
                  fontWeight: "bold",
                  fontSize: "0.95rem",
                  color: "#2d3748",
                },
              }}
              muiTableBodyCellProps={{
                sx: {
                  fontSize: "0.9rem",
                },
              }}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default ReceiptVouchers;
